import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoadingService } from '../services/loading/loading.service';
import { AuthService } from '../services/auth/auth.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css'],
})
export class ForgetPasswordComponent {
  logo = './assets/' + environment.projectName + '/media/header/logo.png';
  lang: string = '';
  phone: string = '';
  showModal: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private loader: LoadingService
  ) {
    this.route.params.subscribe((params) => {
      if (params) {
        this.lang = params['lang'];
      }
    });
  }

  forgetPassword() {
    const phonePattern = /^[0-9]{10,15}$/;
    if (!phonePattern.test(this.phone)) {
      alert('Please enter a valid phone number');
      return;
    }
    this.loader.showLoading();
    this.authService.forgotPassword(this.phone).subscribe({
      next: (response) => {
        this.loader.hideLoading();
        this.showModal = true;
      },
      error: (error) => {
        this.loader.hideLoading();
      },
    });
  }

  goToOtp() {
    this.showModal = false;
    this.router.navigate(['/' + this.lang + '/otpcode'], {
      queryParams: { phone: this.phone },
    });
  }
}